module.exports = __webpack_public_path__ + "img/1557614105627533314.36ae32ef.png";